import { __decorate } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import { BootstrapBadge, BootstrapIcon, BootstrapLink } from '../../../dsl/front';
import { LabelColor } from '../../_contracts';
import { ListWithAddonsMixin } from '../ui/ListWithAddonsMixin';
import { PublicationDate } from '../PublicationDate';
import { ReadingTime } from '../ReadingTime';
/**
 * Text list item component that renders individual article items
 * Used by both TextList and TextListWithAddons components
 */
let TextListItem = class TextListItem extends ListWithAddonsMixin {
    get showBadge() {
        if (!this.listConfig) {
            return false;
        }
        if (typeof this.listConfig.showArticleTags === 'undefined') {
            return false;
        }
        return this.listConfig.showArticleTags;
    }
    /**
     * Searches the article's badges (labels) for the 1st one in the red color
     * and returns it if found.
     *
     * @param article - The article to search within.
     */
    getRedBadge(article) {
        if (article.properties.labels !== null &&
            Array.isArray(article.properties.labels) &&
            article.properties.labels.length > 0) {
            return article.properties.labels.find(label => label.color === LabelColor.Red);
        }
        return undefined;
    }
    /**
     * Resolves the CSS modifier class that describes the site
     * that the given article belongs to.
     *
     * @param article - The source article.
     */
    getSiteModifier(article) {
        if (typeof article === 'undefined' || typeof article.site !== 'number') {
            return '';
        }
        return `--site-${article.site}`;
    }
    /**
     * Method to get proper article title
     *
     * @param article - The article to render.
     */
    getTitle(article) {
        if (!this.listConfig) {
            return article.title;
        }
        if (!this.listConfig.titleVersion) {
            return article.title;
        }
        if (typeof article.properties.additionalTitles !== 'object' || article.properties.additionalTitles === null ||
            !article.properties.additionalTitles[this.listConfig.titleVersion]) {
            return article.title;
        }
        return article.properties.additionalTitles[this.listConfig.titleVersion];
    }
    getLabels(article) {
        if (article.properties.labels !== null &&
            Array.isArray(article.properties.labels) &&
            article.properties.labels.length > 0) {
            return article.properties.labels;
        }
        return [];
    }
    /**
     * Determines whether the article has any labels to display (either premium or regular labels).
     *
     * @param article - The article to check.
     */
    hasAnyLabels(article) {
        return article.paywall || this.getLabels(article).length > 0;
    }
    /**
     * Determines whether the passed-in article has any red badges (labels) associated.
     *
     * @param article - The article to check.
     */
    hasRedBadge(article) {
        return typeof this.getRedBadge(article) !== 'undefined';
    }
};
__decorate([
    Prop({ type: Object, required: true })
], TextListItem.prototype, "item", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], TextListItem.prototype, "withoutBadge", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], TextListItem.prototype, "showPublicationDate", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], TextListItem.prototype, "showReadingTime", void 0);
TextListItem = __decorate([
    Component({
        name: 'TextListItem',
        components: {
            BootstrapBadge,
            BootstrapIcon,
            BootstrapLink,
            PublicationDate,
            ReadingTime
        },
        template: `
    <li class="text-list__list__item" :class="getSiteModifier(item.data)">
    <BootstrapLink :link="{ target: { path: item.data.urlPath } }" class="stretched-link">
      <!--<BootstrapBadge v-if="hasRedBadge(item.data) && showBadge && !withoutBadge" size="small"
                      class="text-list__list__item__badge">
        {{ getRedBadge(item.data).name }}
      </BootstrapBadge>-->

      <!-- Labels -->
      <div v-if="showBadge && hasAnyLabels(item.data)" class="text-list__labels" v-clamp="3">
        <!-- Premium without other labels: show "PREMIUM" with icon -->
        <span v-if="item.data.paywall && (!getLabels(item.data) || getLabels(item.data).length === 0)"
              class="text-list__list__item__label">
            <BootstrapBadge theme="blue">
              <BootstrapIcon name="premium" size="small" />
              premium
            </BootstrapBadge>
          </span>
        <!-- Premium with other labels: show icon + label name for each label -->
        <span v-else-if="item.data.paywall && getLabels(item.data) && getLabels(item.data).length > 0"
              v-for="(label, index) in getLabels(item.data)" :key="label.name + index"
              class="text-list__list__item__label">
            <BootstrapBadge :theme="label.color">
              <BootstrapIcon name="premium" size="small" />
              {{ label.name }}
            </BootstrapBadge>
          </span>
        <!-- Non-premium: show only labels without premium icon -->
        <span v-else-if="!item.data.paywall"
              v-for="(label, index) in getLabels(item.data)" :key="label.name + index"
              class="text-list__list__item__label">
            <BootstrapBadge :theme="label.color">
              {{ label.name }}
            </BootstrapBadge>
          </span>
        <span class="text-list__list__item__title">
            {{ getTitle(item.data) }}
          </span>
      </div>
      <div v-else v-clamp="3">
          <span class="text-list__list__item__title">
            {{ getTitle(item.data) }}
          </span>
      </div>
      <!-- END | Labels -->

      <div class="text-list__list__item__footer">
        <PublicationDate v-if="showPublicationDate" :value="item.data.publicationDate" :shortenDate="true" />
        <ReadingTime v-if="showReadingTime && item.data.readingTime" :time="item.data.readingTime" />
        <span v-if="item.data && item.data.sponsored" class="text-list__list__item__sponsored">
            Materiał sponsorowany
          </span>
      </div>
    </BootstrapLink>
    </li>
  `
    })
], TextListItem);
export { TextListItem };
